var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3333,
    cy: 22,
    r: 22,
    fill: "#EF4949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9336 31.6007V24.5687C31.9336 21.1127 31.1896 18.4727 27.1576 18.4727C25.2136 18.4727 23.9176 19.5287 23.3896 20.5367H23.3416V18.7847H19.5256V31.6007H23.5096V25.2407C23.5096 23.5607 23.8216 21.9527 25.8856 21.9527C27.9256 21.9527 27.9496 23.8487 27.9496 25.3367V31.5767H31.9336V31.6007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0452 18.7842H17.0292V31.6002H13.0452V18.7842Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0376 12.4004C13.7656 12.4004 12.7336 13.4324 12.7336 14.7044C12.7336 15.9764 13.7656 17.0324 15.0376 17.0324C16.3096 17.0324 17.3416 15.9764 17.3416 14.7044C17.3416 13.4324 16.3096 12.4004 15.0376 12.4004V12.4004Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bf36c9ab118b5141d2405a7c76471548.svg";
export { ForwardRef as ReactComponent };